<template>
  <button
    class="theme-toggle"
    @click="toggle"
    :aria-label="theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'"
  >
    <svg
      v-if="theme === 'dark'"
      class="icon"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <circle cx="12" cy="12" r="4" />
      <path
        d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"
      />
    </svg>
    <svg
      v-else
      class="icon"
      viewBox="0 0 24 24"
      fill="currentColor"
      stroke="none"
    >
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
    </svg>
  </button>
</template>

<script>
export default {
  name: "ThemeToggle",
  data: function () {
    return { theme: "dark" };
  },
  created: function () {
    this.theme =
      document.documentElement.getAttribute("data-theme") || "dark";
  },
  methods: {
    toggle: function () {
      this.theme = this.theme === "dark" ? "light" : "dark";
      document.documentElement.setAttribute("data-theme", this.theme);
      try {
        localStorage.setItem("theme", this.theme);
      } catch (e) {
        /* localStorage unavailable */
      }
      const meta = document.querySelector('meta[name="theme-color"]');
      if (meta) {
        meta.setAttribute(
          "content",
          this.theme === "dark" ? "#000000" : "#ffffff"
        );
      }
    }
  }
};
</script>

<style scoped>
.theme-toggle {
  position: fixed;
  top: 25px;
  left: 20px;
  z-index: 10;
  background: none;
  border: none;
  padding: 8px;
  margin: 0;
  cursor: pointer;
  color: var(--text);
  opacity: 0.5;
  transition: opacity 0.25s cubic-bezier(0.075, 0.82, 0.165, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-tap-highlight-color: transparent;
}

.theme-toggle:hover {
  opacity: 1;
}

.icon {
  width: 22px;
  height: 22px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/ThemeToggle.vue